// extracted by mini-css-extract-plugin
export default {"RelatedEstimates__address":"styles_RelatedEstimates__address__np3DG","RelatedEstimates__noteTitle":"styles_RelatedEstimates__noteTitle__k+WI5"};